import { createFileRoute } from "@tanstack/react-router";

import CreateLead from "@/pages/CreateLead";
import { COUNTRY_PRODUCT_IDs } from "@/utils/constants";

const EditLeadComponent = () => {
  const { leadId } = Route.useParams();
  const leadIdNumber = Number.parseInt(leadId, 10);

  return (
    <CreateLead
      countryProductId={COUNTRY_PRODUCT_IDs.CREDIT_CARD}
      editLeadId={leadIdNumber}
    />
  );
};

export const Route = createFileRoute("/_authenticated/lead/edit/$leadId")({
  component: EditLeadComponent,
});
